export default __webpack_public_path__ + "static/media/Rojo.e9d57698.jpg";